<template>
  <div class="generated-keys-table-wrapper">
    <caption class="sr-only">
      Generated API keys with name, created date, expiry date, and active status
    </caption>
    <KTable
      :headers="kableHeaders"
      :rows="kableRows"
      :hideable="false"
      :show-controls="false"
      :panel="false"
      :max="10"
      :loading="loading"
      :support-row-click="true"
    />
  </div>
</template>

<script>
import KTable from '@base-components/tables/display/k-table.vue';
import TimeMixin from '@mixins/time-mixins';

export default {
  components: {
    KTable,
  },

  mixins: [TimeMixin],

  props: {
    keys: {
      type: Array,
      required: true,
    },
    labelledBy: {
      type: String,
      default: 'generated-keys-heading',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    kableHeaders() {
      return {
        name: {
          name: 'Name',
          type: 'string',
          sortable: true,
        },
        created: {
          name: 'Created',
          type: 'date',
          sortable: true,
          displayAs: this.formatDate,
        },
        expires: {
          name: 'Expires',
          type: 'date',
          sortable: true,
          displayAs: this.formatDate,
        },
        active: {
          name: 'Active',
          type: 'boolean',
          sortable: true,
        },
      };
    },

    kableRows() {
      return this.keys.map(key => ({
        name: key.key_name,
        created: key.date_created,
        expires: key.expire_time,
        active: key.active,
      }));
    },
  },

  methods: {
    formatDate(value) {
      if (!value) {
        return '—';
      }
      return this.parseTimestamp(value, undefined, 'd MMM yyyy');
    },
  },
};
</script>
